import $ from 'jquery';

const $videoYoutubeImage = $('.video-youtube__iframe-image');
const $videoHomepageImage = $('.video-homepage__iframe-image');
const $videoBlogImage = $('.video-blog__iframe-image');

$videoYoutubeImage.on("click", () => {
    $videoYoutubeImage.addClass("image-hidden");
});

$videoHomepageImage.on("click", () => {
    $videoHomepageImage.addClass("image-hidden");
});

$videoBlogImage.on("click", () => {
    $videoBlogImage.addClass("image-hidden");
});



